import React, { useState, useEffect } from 'react'; // ✅ Fixed: Added useEffect import
import { Input, Button, Space, notification } from 'antd';
import SearchBox2 from '../functions/Search_Generic';
import api from '../functions/api'; // Make sure this path is correct

const AddTicker = ({ closeModal, prefilledTicker = '' }) => {
  const [companyName, setCompanyName] = useState('');
  const [definitiveTicker, setDefinitiveTicker] = useState(prefilledTicker); // Prefilled ticker

  useEffect(() => {
    setDefinitiveTicker(prefilledTicker); // ✅ Ensure ticker updates when modal opens
  }, [prefilledTicker]);

  const handleDefinitiveTickerChange = (e) => {
    setDefinitiveTicker(e.target.value);
  };

  const handleCompanyNameChange = (e) => {
    setCompanyName(e.target.value);
  };

  const handleSave = async () => {
    if (!definitiveTicker.trim() || !companyName.trim()) {
      notification.error({
        message: 'Error',
        description: 'Both ticker and company name are required.',
      });
      return;
    }

    try {
      console.log('Sending request with data:', { ticker: definitiveTicker, company: companyName });
      const response = await api.post('/add_Ticker', { ticker: definitiveTicker, company: companyName });
      console.log('Response received:', response);
      notification.success({
        message: 'Success',
        description: response.data.message || 'Ticker added successfully.',
      });
      closeModal(); 
    } catch (error) {
      console.error('Error saving ticker:', error);
      notification.error({
        message: 'Error',
        description: 'Failed to add ticker. Please try again.',
      });
    }
  };

  return (
    <Space direction="vertical">
      <SearchBox2 onSelectTicker={setDefinitiveTicker} /> {/* ✅ Fixed: Directly update definitiveTicker */}
      <Input
        placeholder="Definitive Ticker"
        value={definitiveTicker}
        onChange={handleDefinitiveTickerChange}
      />
      <Input 
        placeholder="Company Name" 
        value={companyName} 
        onChange={handleCompanyNameChange} 
      />
      <Space>
        <Button type="primary" onClick={handleSave}>Save</Button>
        <Button onClick={closeModal}>Cancel</Button>
      </Space>
    </Space>
  );
};

export default AddTicker;
